import $ from 'jquery';

const findInsurance            = {
	init: () => {
		const nextButton       = $( '.js-insurance-next' );
		const prevButton       = $( '.js-insurance-prev' );
		const summaryButton    = $( '.js-insurance-summary' );
		const openModalButton  = $( '.js-open-insurance-modal' );
		const closeModalButton = $( '.js-close-insurance-modal' );
		const modal            = $( '.js-insurance-modal' );
		const steps            = $( '.js-insurance-step' );
		const summary          = $( '.js-insurance-summary' );
		const progressbarSteps = $( '.find-insurance__progressbar li' );
		const form             = $( '.find-insurance__form' );
		// const summaryButtonsMobile = $('.summary-buttons-mobile');

		openModalButton.click(
			function(e) {
				e.preventDefault();
				modal.fadeIn();
				$( 'body' ).addClass( 'modal-open' );
			}
		);

		closeModalButton.click(
			function(e) {
				e.preventDefault();
				modal.fadeOut();
				$( 'body' ).removeClass( 'modal-open' );
			}
		)

		nextButton.each(
			function() {
				$( this ).click(
					function(e) {
						e.preventDefault();
						const currentStep  = $( this ).closest( '.js-insurance-step' );
						const currentIndex = currentStep.index() - 1;
						const nextStep     = steps.eq( currentIndex + 1 );
						if (nextStep.length > 0) {
							progressbarSteps.eq( currentIndex + 1 ).addClass( 'active' );
							currentStep.fadeOut(
								function() {
									nextStep.fadeIn();
								}
							);

						}
					}
				)
			}
		);
		prevButton.each(
			function() {
				$( this ).click(
					function(e) {
						e.preventDefault();
						const currentStep  = $( this ).closest( '.js-insurance-step' );
						const currentIndex = currentStep.index() - 1;
						const prevStep     = steps.eq( currentIndex - 1 );
						console.log( prevStep );
						if (prevStep.length > 0) {
							progressbarSteps.eq( currentIndex ).removeClass( 'active' );
							currentStep.fadeOut(
								function() {
									prevStep.fadeIn();
								}
							);

						}
					}
				)
			}
		);
		form.on(
			'submit',
			function(e) {
				e.preventDefault();
				$( '.find-insurance__progressbar' ).fadeOut();
				steps.last().fadeOut(
					function() {
						summary.fadeIn();
						$.ajax(
							{
								url:form.attr( 'action' ),
								data:form.serialize(),
								type:form.attr( 'method' ),
								beforeSend:function(xhr) {
									$( '.loader-container' ).show();
								},
								success:function (data) {
									$( '.loader-container' ).hide();
									$( '.find-insurance__step-inputs' ).html( data );
								}
							}
						)
						// summaryButtonsMobile.addClass('visible');
					}
				);

			}
		)
	}
}

export default findInsurance;
